import React from "react";
import "./MasterUser.scss";
import { FormattedMessage } from "react-intl";
import * as _ from "lodash-es";

type Props = {
    isMaster: boolean;
    title?: string;
    icon?: string;
    supplierModel?: any;
    isSupplierVendorOverride?: boolean;
};

const MasterUser: React.FC<Props> = (props) => {
    let { title } = props;

    const { supplierModel, isSupplierVendorOverride, isMaster, icon } = props;

    if (title && isSupplierVendorOverride && supplierModel && !_.isNil(supplierModel.vendor_name_override)) {
        title = title.replace(/vendor/, supplierModel.vendor_name_override);
    } else {
        title = "master_user";
    }

    return (
        <span className={isMaster ? "" : "d-none"}>
            <i className={"text-warning " + icon} />{" "}
            <FormattedMessage id={`${title}`} defaultMessage={title} description="Master User Title" />
        </span>
    );
};

export default MasterUser;
